// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * SUREnet producten-internal API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfProductenPakkettenPakketDto } from '../model/collectionResultOfProductenPakkettenPakketDto';

import type { ProductenPakkettenPakketDto } from '../model/productenPakkettenPakketDto';

import type { Result1OfProductenPakkettenPakketDto } from '../model/result1OfProductenPakkettenPakketDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
 * @summary Geeft een lijst van pakketten terug.
 */
export const pakkettenAll = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfProductenPakkettenPakketDto>(
    { url: `/api/v1/pakketten`, method: 'GET', signal },
    options,
  );
};

export const getPakkettenAllQueryKey = () => {
  return ['api', 'v1', 'pakketten'] as const;
};

export const getPakkettenAllQueryOptions = <
  TData = Awaited<ReturnType<typeof pakkettenAll>>,
  TError = ErrorType<null | null>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenAll>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPakkettenAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pakkettenAll>>> = ({ signal }) =>
    pakkettenAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof pakkettenAll>>,
    TError,
    TData
  >;
};

export type PakkettenAllQueryResult = NonNullable<Awaited<ReturnType<typeof pakkettenAll>>>;
export type PakkettenAllQueryError = ErrorType<null | null>;

/**
 * @summary Geeft een lijst van pakketten terug.
 */

export function usePakkettenAll<
  TData = Awaited<ReturnType<typeof pakkettenAll>>,
  TError = ErrorType<null | null>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenAll>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPakkettenAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
 * @summary Voegt een nieuw pakket toe of wijzigt een bestaande.
 */
export const pakkettenPost = (
  productenPakkettenPakketDto: MaybeRef<ProductenPakkettenPakketDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  productenPakkettenPakketDto = unref(productenPakkettenPakketDto);

  return customInstance<null>(
    {
      url: `/api/v1/pakketten`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: productenPakkettenPakketDto,
      signal,
    },
    options,
  );
};

export const getPakkettenPostMutationOptions = <
  TError = ErrorType<null | null | null | null>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pakkettenPost>>,
    TError,
    { data: ProductenPakkettenPakketDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pakkettenPost>>,
  TError,
  { data: ProductenPakkettenPakketDto },
  TContext
> => {
  const mutationKey = ['pakkettenPost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pakkettenPost>>,
    { data: ProductenPakkettenPakketDto }
  > = (props) => {
    const { data } = props ?? {};

    return pakkettenPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PakkettenPostMutationResult = NonNullable<Awaited<ReturnType<typeof pakkettenPost>>>;
export type PakkettenPostMutationBody = ProductenPakkettenPakketDto;
export type PakkettenPostMutationError = ErrorType<null | null | null | null>;

/**
 * @summary Voegt een nieuw pakket toe of wijzigt een bestaande.
 */
export const usePakkettenPost = <TError = ErrorType<null | null | null | null>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pakkettenPost>>,
      TError,
      { data: ProductenPakkettenPakketDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof pakkettenPost>>,
  TError,
  { data: ProductenPakkettenPakketDto },
  TContext
> => {
  const mutationOptions = getPakkettenPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
 * @summary Haalt een pakket op, op basis van pakketId
 */
export const pakkettenGetByPakketId = (
  pakketId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  pakketId = unref(pakketId);

  return customInstance<Result1OfProductenPakkettenPakketDto>(
    { url: `/api/v1/pakketten/${pakketId}`, method: 'GET', signal },
    options,
  );
};

export const getPakkettenGetByPakketIdQueryKey = (
  pakketId?: MaybeRef<string | undefined | null>,
) => {
  return ['api', 'v1', 'pakketten', pakketId] as const;
};

export const getPakkettenGetByPakketIdQueryOptions = <
  TData = Awaited<ReturnType<typeof pakkettenGetByPakketId>>,
  TError = ErrorType<null | null | null>,
>(
  pakketId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetByPakketId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPakkettenGetByPakketIdQueryKey(pakketId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pakkettenGetByPakketId>>> = ({ signal }) =>
    pakkettenGetByPakketId(pakketId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(pakketId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetByPakketId>>, TError, TData>;
};

export type PakkettenGetByPakketIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof pakkettenGetByPakketId>>
>;
export type PakkettenGetByPakketIdQueryError = ErrorType<null | null | null>;

/**
 * @summary Haalt een pakket op, op basis van pakketId
 */

export function usePakkettenGetByPakketId<
  TData = Awaited<ReturnType<typeof pakkettenGetByPakketId>>,
  TError = ErrorType<null | null | null>,
>(
  pakketId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetByPakketId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPakkettenGetByPakketIdQueryOptions(pakketId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
